import styled from 'styled-components'

export const Track = styled.button<{ $checked: boolean }>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  width: 40px;
  height: 20px;
  padding: 2px;
  border-radius: 40px;
  border: 1px solid
    ${({ theme, $checked }) =>
      $checked ? theme.color.brandGreen : theme.color.lightGrey};
  background-color: ${({ theme, $checked }) =>
    $checked ? theme.color.brandGreen : theme.color.lightGrey};
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.darkGreen};
    outline-offset: 1px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const Knob = styled.span<{ $checked: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  transform: translateX(${({ $checked }) => ($checked ? '20px' : '0')});
  transition: transform 0.2s ease;
`
